// This import loads the firebase namespace along with all its type information.
import GameMarketingResource from './game-marketing-resource-model'

export async function load_gameMarketingResources(): Promise<
  GameMarketingResource[]
> {
  throw 'Not implemented'
}

export async function delete_gameMarketingResource(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameMarketingResource(): Promise<GameMarketingResource> {
  throw 'Not implemented'
}
